<template>
  <div class="keyVisualWrapper" :style="styles">
    <div :class="{'container': !noContainer}">
      <div :class="{'row':addRow}">
        <img class="desktop_img img-fluid w-100" :src="$t('desktopBanner')" :alt="$t('bannerAltText')" />
        <img class="tablet_img img-fluid w-100" :src="$t('tabletBanner')" :alt="$t('bannerAltText')" :style="tabletImgStyles" />
        <img class="mobile_img img-fluid w-100" :src="$t('mobileBanner')" :alt="$t('bannerAltText')" :style="mobileImgStyles" />
        <p class="banner-text">{{ $t('bannerAltText') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "key-visual",
  props: {
    desktopImageUrl: {
      type: String
    },
    mobileImageUrl: {
      type: String
    },
    tabletImageUrl: {
      type: String
    },
    addRow: {
      type: Boolean
    },
    noContainer: {
      type: Boolean
    },
    mobileImgStyles: {
      type: Object,
      default: () => {}
    },
    tabletImgStyles: {
      type: Object,
      default: () => {}
    },
    styles: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style scoped lang="scss">
  .keyVisualWrapper {
    position: relative;
  }

.desktop_img {
  @media (max-width: 768px) {
    display: none;
  }
}

.tablet_img {
  @media (max-width: 435px), (min-width: 769px) {
    display: none;
  }
}

.mobile_img {
  @media (min-width: 436px) {
    display: none;
  }
}

.banner-text {
  font-size: 11px;
  line-height: 1.2;
  color: #000000;
  margin: 5px 0 0 0;
  padding: 0;
  text-align: center;
  opacity: 1;
}

</style>
